/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Due_AtInputs */

const cs_form_due_at = /** @type {(inputs: Form_Due_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termín`)
};

const en_form_due_at = /** @type {(inputs: Form_Due_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due`)
};

/**
* | output |
* | --- |
* | "Due" |
*
* @param {Form_Due_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_due_at = /** @type {((inputs?: Form_Due_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Due_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_due_at(inputs)
	return cs_form_due_at(inputs)
});